export default __webpack_public_path__ + "static/media/screens.8f117bab.svg";